import { render, staticRenderFns } from "./ConsentCheck.vue?vue&type=template&id=8276bb14&"
import script from "./ConsentCheck.vue?vue&type=script&lang=ts&"
export * from "./ConsentCheck.vue?vue&type=script&lang=ts&"
import style0 from "./ConsentCheck.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports